import { deliveryMenus } from "./menus";
import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Volver",
	updateManyExternalIntegrations: {
		success: "Integraciones actualizadas con éxito",
	},
	externalStoreIntegrationStatus: {
		synced: "Sincronizado",
		pendingSyncing: "Sincronización pendiente",
		pendingImporting: "Importación pendiente",
	},
	ordersManager: {
		title: "Gestor de pedidos",
		description:
			"Rastrea y gestiona los pedidos que llegan de Entregue já, Comanda Online y Pedido na mesa.",
		filter: {
			placeholder: "Filtrar por",
		},
		tabs: {
			newOrders: "Nuevos Pedidos",
			completed: "Concluidos",
		},
		loading: "Cargando",
		total: "Total: {{value}}",
		new: "Nuevo",
		emptyState: {
			title: "Aún no tenemos pedidos pendientes.",
			description: "Aquí mostraremos cuando recibas nuevos pedidos.",
		},
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
